__turbopack_context__.v({
  "accessory": "menu-module__8dD-kG__accessory",
  "check": "menu-module__8dD-kG__check",
  "chevron": "menu-module__8dD-kG__chevron",
  "denseRows": "menu-module__8dD-kG__denseRows",
  "detached": "menu-module__8dD-kG__detached",
  "head": "menu-module__8dD-kG__head",
  "icon": "menu-module__8dD-kG__icon",
  "item": "menu-module__8dD-kG__item",
  "itemDesc": "menu-module__8dD-kG__itemDesc",
  "itemLabel": "menu-module__8dD-kG__itemLabel",
  "itemText": "menu-module__8dD-kG__itemText",
  "menu": "menu-module__8dD-kG__menu",
  "menuLabel": "menu-module__8dD-kG__menuLabel",
  "menuNote": "menu-module__8dD-kG__menuNote",
  "separator": "menu-module__8dD-kG__separator",
  "sheetMenu": "menu-module__8dD-kG__sheetMenu",
  "value": "menu-module__8dD-kG__value",
  "wrap": "menu-module__8dD-kG__wrap",
});
